import { Theme, createStyles, makeUiStyles } from "../styles/styles";
import { SkipLinkStyleModel } from "./tools/SkipLink.const";
import { fontSize, fontText, StylesIndexInjections } from "common-react";

export default makeUiStyles(
  (theme: Theme) =>
    createStyles({
      wrapper: {
        width: 0,
        height: 0,
      },
      root: (props: SkipLinkStyleModel) => ({
        position: "absolute",
        zIndex: theme.zIndex.modal,
        top: "auto",
        left: -999,
        width: 0,
        height: 0,
        display: "flex",
        ...(props?.isScreenReaderVisibilityEnabled && {
          "&:focus": {
            top: "env(safe-area-inset-top, 0px)",
            left: "env(safe-area-inset-left, 0px)",
            color: theme.color.greys[0],
            width: "auto",
            height: "auto",
            margin: "auto",
            display: "inline-block",
            outline: "none",
            padding: 8,
            font: fontText("normal", fontSize.base, 16),
            background: theme.color.violets[100],
            borderBottomRightRadius: 8,
          },
        }),
      }),
    }),
  { name: "SkipLink", index: StylesIndexInjections.UI_ATOMS }
);
